import AssignmentTurnedInIcon from "@mui/icons-material/AssignmentTurnedIn";
import CancelIcon from "@mui/icons-material/Cancel";
import CheckCircleIcon from "@mui/icons-material/CheckCircle";
import HelpOutlineIcon from "@mui/icons-material/HelpOutline";
export const getStatusInfo = (status) => {
  const statusMap = {
    pending: {
      label: "pending",
      color: "#f97316", // orange
      Icon: AssignmentTurnedInIcon,
    },
    accepted: {
      label: "accepted",
      color: "#22c55e", // vert
      Icon: CheckCircleIcon,
    },
    invoiced: {
      label: "invoiced",
      color: "#2563eb", // bleu
      Icon: CheckCircleIcon,
    },
    refused: {
      label: "refused",
      color: "#ef4444", // rouge
      Icon: CancelIcon,
    },
    Inconnu: {
      label: "Inconnu",
      color: "#6b7280", // gris
      Icon: HelpOutlineIcon,
    },
  };

  return statusMap[status] || statusMap["Inconnu"];
};
export const StatusResponse = {
  ALL: "all",
  ACCEPTED: "accepted",
  REFUSED: "refused",
  PENDING: "pending",
  INVOICED: "invoiced",
};
